export default __webpack_public_path__ + "static/ibmplexmono-thin-95b66373f6b8c0de646fdf08f87d8e48.woff";